import React from 'react'
import PropTypes from 'prop-types'
import withOutsideClickHandler from 'shared/hocs/withOutsideClickHandler'
import { SearchForm } from 'LiveBoard/components/shared/SearchForm'
import { scrollToElement } from 'LiveBoard/components/mobile/helper'
import { LIVE_BOARD_CLASSNAMES } from 'shared/constants'

import './style.css.scss'

class Search extends React.Component {
  constructor(props) {
    super(props)

    this.state = { isOpen: false }
  }

  componentDidMount() {
    this.props.provideContainer(this.searchContainer)
    this.props.provideOutsideClickHandler(this.close)
  }

  componentWillUnmount() {
    this.props.provideContainer(null)
    this.props.provideOutsideClickHandler(null)
  }

  toggleIsOpen = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  close = () => {
    this.setState({ isOpen: false })
  }

  handleSubmit = (query) => {
    this.props.onSubmit(query)
    this.close()
    scrollToElement({elemClass: LIVE_BOARD_CLASSNAMES.items, addViewPort: true})
  }

  render() {
    const { isOpen } = this.state
    const { form, solidBackground } = this.props

    return (
      <div
        className={`search-container ${isOpen ? 'open' : ''} ${solidBackground ? 'solid' : ''}`}
        ref={ref => this.searchContainer = ref} >
        <span className="icon-search" onClick={this.toggleIsOpen} />
        { isOpen && (
          <div className="search-panel">
            <SearchForm
              form={form}
              onSubmit={this.handleSubmit}
              solidBackground={solidBackground} />
          </div>
        )}
      </div>
    )
  }
}

Search.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  solidBackground: PropTypes.bool.isRequired,
  provideContainer: PropTypes.func,
  provideOutsideClickHandler: PropTypes.func
}

export default withOutsideClickHandler(Search)
